export enum RuleCategory {
  DoNotCode = 1,
  DocumentationRequired = 2,
  ConflictingDiagnosis = 3,
}

export const RuleCategoryDisplay: Record<RuleCategory, string> = {
  [RuleCategory.DoNotCode]: 'Do Not Code',
  [RuleCategory.DocumentationRequired]: 'Documentation Required',
  [RuleCategory.ConflictingDiagnosis]: 'Conflicting Diagnosis',
};

export enum RuleSeverity {
  Blocker = 1,
  Warning = 2,
  Info = 3,
}

export const RuleSeverityDisplay: Record<RuleSeverity, string> = {
  [RuleSeverity.Blocker]: 'Blocker',
  [RuleSeverity.Warning]: 'Warning',
  [RuleSeverity.Info]: 'Info',
};

export enum RuleMatchType {
  ICDCodes = 1,
}

export const RuleMatchTypeDisplay: Record<RuleMatchType, string> = {
  [RuleMatchType.ICDCodes]: 'ICD Codes',
};

export enum RuleEvidenceType {
  ROS = 1,
  PE = 2,
  Diabetes = 3,
  AP = 4,
}

export const RuleEvidenceTypeDisplay: Record<RuleEvidenceType, string> = {
  [RuleEvidenceType.ROS]: 'Review of Systems',
  [RuleEvidenceType.PE]: 'Physical Examination',
  [RuleEvidenceType.Diabetes]: 'Diabetes',
  [RuleEvidenceType.AP]: 'Assessment Plan',
};

export enum RuleConflictType {
  CrossGroup = 1,
  MutuallyExclusive = 2,
}

export const RuleConflictTypeDisplay: Record<RuleConflictType, string> = {
  [RuleConflictType.CrossGroup]: 'Cross Group',
  [RuleConflictType.MutuallyExclusive]: 'Mutually Exclusive',
};
